import {ChangeDetectorRef, Component, Input, ViewEncapsulation, inject} from '@angular/core';

@Component({
    selector: 'app-ui-modal',
    templateUrl: './ui-modal.component.html',
    styleUrls: ['./ui-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UiModalComponent {
  private cdr = inject(ChangeDetectorRef);
  @Input() dialogClass!: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() containerClick = true;
  public visible = false;
  public visibleAnimate = false;
  @Input() modalCentered = false;
  @Input() loadSpinner = false; 



  public show(): void {
    this.visible = true;
    this.cdr.markForCheck();
    setTimeout(() => {
      this.visibleAnimate = true;
      this.cdr.markForCheck();
    }, 100);
    document?.querySelector('body')?.classList.add('modal-open');
  }

  public hide(): void {
    this.visibleAnimate = false;
    this.cdr.markForCheck();
    // this.loadSpinner = false;
    setTimeout(() => {
      this.visible = false;
      this.cdr.markForCheck();
    }, 300);
    document.querySelector('body')?.classList.remove('modal-open');
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal') && this.containerClick === true) {
      this.hide();
    }
  }

}
